module.exports = __webpack_public_path__ + "static/media/feed.f41b3b0f.svg";